<style lang="less" scoped>
.desc-col {
  margin-bottom: 12px;
}

.desc-label {
  width: 100%;
  font-size: 14px;
  color: #91949f;
  white-space: nowrap;
  /* 规定文本是否折行 */
  overflow: hidden;
  /* 规定超出内容宽度的元素隐藏 */
  text-overflow: ellipsis;
  line-height: 20px;
  height: 20px;
  margin-bottom: 8px;
}

.desc-text {
  line-height: 22px;
  font-size: 14px;
  color: #222327;
  font-weight: 400;
}

.desc .el-row:last-child .desc-col {
  margin-bottom: 0;
}

/deep/ .el-select,
/deep/ .el-input,
/deep/ .el-cascader,
/deep/.el-date-editor {
  width: 100%;
}
/deep/ .desc-label{
  position: relative;
}
/deep/ .desc-active{
  padding-left: 10px;
}
/deep/ .desc-active::after{
  position: absolute;
  content: '*';
  left: 0;
  top: 0;
  color: #F56C6C;
}
</style>

<template>
  <div class="desc">
    <el-row v-for="(row, key) in createLayout" :key="key" :gutter="48">
      <el-col v-for="col in row" :key="col.id" :span="col.span" class="desc-col">
        <div :class="['desc-label',{'desc-active': col.isMust}]">{{ col.label }}</div>
        <div v-if="col.slot != null && col.slot != undefined && col.slot != ''" class="desc-text">
          <slot :name="col.slot" :col="col" :data="data" />
        </div>
        <div v-else class="desc-text">
          {{ col.before ? col.before : ""
          }}{{
            col.field && data[col.field] ? data[col.field] : col.default || "-"
          }}{{ col.after ? col.after : "" }}
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from "vue";
export default defineComponent({
  props: {
    /**
     * @param {Array} layout 描述布局
     */
    layout: {
      type: Array as PropType<any[]>,
      default: (): PropType<any[]> => [],
    },

    /**
     *@param {Array} data 描述数据
     */
    data: {
      type: Object as PropType<any>,
      default: () => {
        return {};
      },
    },

    /**
     * @param {Object} 依赖的数据源
     */
    //   source: {
    //      type: Object as PropType<any>,
    //      default: (): any => {
    //         return {};
    //      },
    //   },
  },
  setup(props) {
    /**
     * @method createLayout 生成描述布局
     */
    const createLayout = computed((): any => {
      /**
       * @param MAX_GRID    默认 最大栅格数
       */
      const MAX_GRID = 24;
      let index = 0;
      const layoutMulti: any = [];

      const layout: any[] = props.layout.filter((elmeent: any) => {
        // 优化diff
        elmeent.id = Number(
          Math.random().toString().substr(3, 8) + Date.now()
        ).toString(8);

        !elmeent.span ? (elmeent.span = 6) : false;
        return true;
      });

      // 转换成二维数组
      for (let element of layout) {
        if (layoutMulti[index]) {
          const sum = layoutMulti[index]
            .map((el: any) => el.span)
            .reduce((sum: number, nex: number) => sum + nex);

          if (sum >= MAX_GRID) {
            index++;
            layoutMulti.push([element]);
          } else {
            layoutMulti[layoutMulti.length - 1].push(element);
          }
        } else {
          layoutMulti.push([element]);
        }
      }

      return layoutMulti;
    });

    return {
      createLayout,
    };
  },
});
</script>
